import { render, staticRenderFns } from "./questionPaperPop.vue?vue&type=template&id=a62b7a0a&scoped=true"
import script from "./questionPaperPop.vue?vue&type=script&lang=js"
export * from "./questionPaperPop.vue?vue&type=script&lang=js"
import style0 from "./questionPaperPop.vue?vue&type=style&index=0&id=a62b7a0a&prod&lang=less"
import style1 from "./questionPaperPop.vue?vue&type=style&index=1&id=a62b7a0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a62b7a0a",
  null
  
)

export default component.exports